// extracted by mini-css-extract-plugin
module.exports = {"card":"partner_card__9JosG","link":"partner_link__AKrxI"};